import React from 'react';

import { Button } from '@makemydeal/dr-ui-bricks-components';
import { PageHeader } from '@makemydeal/dr-sales-checkin-components';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';

import { ActionBar, DealProposalContainer, HeaderRow } from './DealProposal.styles';
import OfferComments from '../OfferComments/OfferComments';
import { useDealProposals } from '../../hook/useDealProposals';

const handleClick = () => {
    console.log('Deal proposal button clicked');
};

const DealProposal: React.FC = () => {
    const { dealProposals } = useDealProposals();

    if (dealProposals.requestStatus === ApiRequestStatus.Loading) {
        return null;
    }

    return (
        <DealProposalContainer data-testid="deal-proposal-page">
            <HeaderRow data-testid="deal-proposal-header">
                <PageHeader heading="Deal Summary" />
                <ActionBar data-testid="deal-proposal-actions">
                    <Button
                        data-testid="deal-proposal-request-changes-button"
                        width="auto"
                        buttonStyle="secondary"
                        buttonSize="small"
                        onClick={handleClick}
                    >
                        Request Changes/Edit Deal
                    </Button>
                    <Button
                        data-testid="deal-proposal-accept-deal-button"
                        width="160px"
                        buttonStyle="primary"
                        buttonSize="small"
                        onClick={handleClick}
                    >
                        Accept Deal
                    </Button>
                </ActionBar>
            </HeaderRow>
            <OfferComments />
        </DealProposalContainer>
    );
};

export default DealProposal;
